import React from 'react';
import { Shield, Clock, UserCheck, Activity } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export const Hero = () => {
  const trustPoints = [{
    icon: Shield,
    text: 'Ліцензована клініка'
  }, {
    icon: UserCheck,
    text: 'Повна анонімність'
  }, {
    icon: Activity,
    text: 'Досвідчені лікарі'
  }, {
    icon: Clock,
    text: 'Виїзд 24/7'
  }];
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-134">
      <div className="container mx-auto px-4 md:px-6" data-id="element-135">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center" data-id="element-136">
          {/* Content */}
          <div className="w-full lg:w-3/5 flex flex-col order-1 lg:order-1" data-id="element-137">
            <FadeIn delay={0.1} data-id="element-138">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-balance text-center md:text-left" data-id="element-139">
                Анонімна наркологічна допомога
              </h1>
            </FadeIn>

            {/* Mobile Image Placeholder (hidden on desktop) */}
            <FadeIn delay={0.15} className="w-full h-[300px] bg-gray-100 border border-gray-200 flex items-center justify-center mb-6 lg:hidden" data-id="element-140">
              <span className="text-gray-400 font-medium" data-id="element-141">Місце для фото</span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-142">
              <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed max-w-xl text-center md:text-left mx-auto md:mx-0" data-id="element-143">
                Вивід із запою вдома та в стаціонарі. Виїзд бригади за 30–60
                хвилин. Професійне лікування без постановки на облік.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-144">
              <Button size="lg" className="w-full sm:w-auto" data-id="element-145">
                Викликати лікаря
              </Button>
              <Button size="lg" variant="outline" className="w-full sm:w-auto" data-id="element-146">
                Зателефонувати
              </Button>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-147">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-8 border-t border-gray-200" data-id="element-148">
                {trustPoints.map((point, idx) => <div key={idx} className="flex flex-col gap-2" data-id="element-149">
                    <point.icon className="w-5 h-5 text-gray-400" strokeWidth={1.5} data-id="element-150" />
                    <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-151">
                      {point.text}
                    </span>
                  </div>)}
              </div>
            </FadeIn>
          </div>

          {/* Visual Desktop */}
          <FadeIn delay={0.2} direction="left" className="relative hidden lg:flex w-full lg:w-2/5 h-[500px] bg-gray-100 border border-gray-200 items-center justify-center order-2 lg:order-2" data-id="element-152">
            <span className="text-gray-400 font-medium text-lg" data-id="element-153">
              Місце для фото
            </span>

            {/* Decorative elements */}
            <div className="absolute top-8 right-8 w-16 h-16 border border-black/10" data-id="element-154" />
            <div className="absolute bottom-8 left-8 w-32 h-32 border border-black/10" data-id="element-155" />
          </FadeIn>
        </div>
      </div>
    </section>;
};